import React, { Fragment } from "react";

import Backdrop from "../backdrop/backdrop";
import Modal from "../modal/modal";

const Message = (props) => (
  <Fragment>
    {props.message && <Backdrop onClick={props.onHandle} />}
    {props.message && (
      <Modal
        title="Message"
        onCancelModal={props.onHandle}
        onAcceptModal={props.onHandle}
        acceptEnabled
        button={"accept"}
      >
        <p style={{ fontSize: "1.5rem" }}>{props.message.message}</p>
      </Modal>
    )}
  </Fragment>
);

export default Message;
